import {
  COMBINED_MEDIA_DOWNLOAD_SIZES,
  ORIGINAL_MEDIA_DOWNLOAD_SIZES,
} from 'app/modules/posts/constants';
import { PostDetail } from 'types/PostDetail';
import { getCardMedia } from 'app/modules/posts/utils/cardMedia';

export const getMediaDownloadSizes = (post: PostDetail) => {
  const cards = post.attachments.cards;
  const hasVideoOnly =
    cards.length > 0 &&
    cards.every((card) => getCardMedia(card)?.kind === 'video');
  const hasDocumentOnly =
    cards.length > 0 &&
    cards.every((card) => getCardMedia(card)?.kind === 'document');
  return hasVideoOnly || hasDocumentOnly
    ? ORIGINAL_MEDIA_DOWNLOAD_SIZES
    : COMBINED_MEDIA_DOWNLOAD_SIZES;
};
